export function getDayNumber(date) {
    var counter = 0;
    for (var year = 2022; year < date.getFullYear(); year++) {
        counter += daysInYear(year);
    }
    return counter + dayOfYear(date);
}
export function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}
export function dayOfYear(date) {
    var counter = 0;
    for (var month = 0; month < date.getMonth(); month++) {
        counter += daysInMonth(month, date.getFullYear());
    }
    return counter + date.getDate();
}
export function isLeapYear(year) {
    if (year % 4 === 0) {
        if (year % 100 === 0) {
            return year % 400 === 0;
        }
        else {
            return true;
        }
    }
    return false;
}
export function daysInMonth(month, year) {
    if (month === 1) {
        return isLeapYear(year) ? 29 : 28;
    }
    else {
        if (month === 3 || month === 5 || month === 8 || month === 10) {
            return 30;
        }
        else {
            return 31;
        }
    }
}
// // Проверка алгоритма getDayNumber
// const start: number = Date.now()
// const msInOneDay: number = 24 * 60 * 60 * 1000
// let prevDayNumber: number = getDayNumber(new Date(start))
//
// for (let i = 1; i < 10000; i++) {
//   const dayNumber: number = getDayNumber(new Date(start + i * msInOneDay))
//   console.log(dayNumber - prevDayNumber)
//   prevDayNumber = dayNumber
// }
